import React from 'react'

export const CheckSimple = () => {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <path
                d="M5 7.99805L7 9.99805L11 5.99805"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            ></path>
        </svg>
    )
}
